import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles/screen-position.css.js";
import withStyles from "components/with-styles";
import { AssetDisplay } from "components/thumbnail";

const ScreenPosition = ({ classes, className, width = 310, screenWidth = 1920, screenHeight = 1080, layouts = [] }) => {
  const ratio = width / screenWidth;

  return (
    <div
      style={{ width: screenWidth * ratio, height: screenHeight * ratio }}
      className={cn(classes.screenPosition, className)}
    >
      {layouts
        .sort((a, b) => a.order - b.order)
        .map((layout, index) => {
          const imgX = layout.pos ? Number(layout.pos.x) * ratio : null;
          const imgY = layout.pos ? Number(layout.pos.y) * ratio : null;

          const imageWidth = layout.size ? Number(layout.size.x) * ratio : null;
          const imageHeight = layout.size ? Number(layout.size.y) * ratio : null;

          return (
            (layout.assetId || layout.id) && (
              <AssetDisplay
                preview
                key={layout.assetId ? layout.assetId : layout.id}
                className={classes.screenPosition__image}
                style={{
                  left: `${imgX}px`,
                  top: `${imgY}px`,
                  zIndex: index,
                }}
                asset={{
                  ...layout.asset,
                  customerId: layout.asset.customerId,
                  id: layout.assetId,
                  image: layout.asset.image,
                  sizePx: layout.size,
                }}
                width={imageWidth}
                height={imageHeight}
              />
            )
          );
        })}
    </div>
  );
};

ScreenPosition.propTypes = {
  /**
   ** Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   ** Ancho del componente
   **/
  width: PropTypes.number,
  /**
   ** Ancho real de la pantalla a representar
   **/
  screenWidth: PropTypes.number,
  /**
   ** Alto real de la pantalla a representar
   **/
  screenHeight: PropTypes.number,
  /**
   ** Asset a representar
   **/
  layouts: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(styles)(ScreenPosition);
